var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModalidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.733,
    height: 16.164,
    viewBox: "0 0 20.733 16.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2995",
    "data-name": "Group 2995",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_616",
    "data-name": "Ellipse 616",
    cx: 1.854,
    cy: 1.854,
    rx: 1.854,
    ry: 1.854,
    transform: "translate(2.109 10.955)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_617",
    "data-name": "Ellipse 617",
    cx: 1.854,
    cy: 1.854,
    rx: 1.854,
    ry: 1.854,
    transform: "translate(12.175 10.955)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M5.106,17.636H3V6.053A1.053,1.053,0,0,1,4.053,5H13.53V17.636m-4.212,0h5.439m5.091,0h2.106V11.318H13.53m0-5.265H18.8l3.159,5.265",
    transform: "translate(-3 -5)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalidad);
export default __webpack_public_path__ + "static/media/icon_modalidad.78de2985f2ebfd552b6f333eb4bbf52d.svg";
export { ForwardRef as ReactComponent };